module.exports = __webpack_public_path__ + "img/face-lines-slider-track.0ba0c0f1.svg";